import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
    };
  }

  render() {
    const { isLoaded } = this.state;

    return (
      <div
        style={{
          backgroundColor: "#FFF8F1",
          minHeight: "100vh",
          paddingTop: "60px",
          paddingBottom: "60px",
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <section className="about-us">
          <div
            className="container"
            style={{
              padding: "0 20px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <div
              className="section-header"
              style={{
                textAlign: "center",
                marginBottom: "40px",
              }}
            >
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "#D86F45",
                  marginBottom: "10px",
                }}
              >
                Pricing
              </h2>
              <div
                style={{
                  height: "4px",
                  width: "80px",
                  margin: "0 auto",
                  backgroundColor: "#FFD6A5",
                  borderRadius: "2px",
                }}
              ></div>
            </div>

            <div className="row justify-content-center">
              {!isLoaded ? (
                <div
                  className="progress-bar-bk"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <CircularProgress color="secondary" />
                </div>
              ) : (
                <div className="col-12">
                  <div
                    className="about-content"
                    style={{
                      backgroundColor: "#FFFFFF",
                      padding: "30px",
                      borderRadius: "16px",
                      boxShadow:
                        "0 6px 20px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)",
                      lineHeight: "1.8",
                      fontSize: "16px",
                      color: "#444",
                    }}
                  >
                    <p style={{ marginBottom: "20px" }}>
                      The price for each product or design is clearly indicated
                      alongside its respective listing. Please note that the
                      site management retains the authority to modify the
                      pricing of any product or design on the site at its
                      discretion, and such adjustments may occur at any time. It
                      is important to emphasize that any alterations in pricing
                      do not impact previously purchased items.
                    </p>

                    <p>
                      Payments can be conveniently made using credit cards or
                      UPI (Unified Payments Interface).
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Pricing;
